export default "https://cdn-static-staging.gokick.com/assets/8452366be4f72804419de7522b15e5b20c0c8dd8/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";